// extracted by mini-css-extract-plugin
module.exports = {"container":"TypeManager_container__2Xylr"};